<template>
    <a
        class="button"
        :class="{
            'button--primary': primary,
            'button--secondary': secondary,
            'is-disabled': disabled,
        }"
        href="javascript:void(0);"
        data-test="button-label"
        @click="onclick"
    >
        <slot/>
    </a>
</template>

<script>
    export default {
        name: 'Button',
        props: {
            primary: {
                type: Boolean,
                default: false
            },
            secondary: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            onclick() {
                if (!this.disabled) {
                    this.$emit('click')
                }
            }
        }
    }
</script>

<style lang="css" scoped src="../../node_modules/@servicensw/buttons/dist/buttons.css"></style>
<style scoped>
    .button--secondary {
        border: 2px solid #c4d0d6 !important;
    }

    .button {
        margin-bottom: 3rem;
    }
</style>
